webpackJsonp([203583327485334],{

/***/ 2040:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"SyncClientResult","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"clientId","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-sync-client-result-c310033bef593d3c0002.js